import * as React from 'react';
import { OptionsViewModel } from '@models/common.models';

const renderOptions = (options: Array<OptionsViewModel>) => {
  if (options && options.length) {
    return options.map((option: OptionsViewModel, index: number) => {
      return (
        <option key={option.id + option.value} value={'' + option.id}>
          {option.value}
        </option>
      );
    });
  }

  return '';
};

export const Options = (props: { options: Array<OptionsViewModel> }) => (
  <>
    <option value="-1">
      {props.options && props.options.length === 0 ? 'No options available' : 'Select one ...'}
    </option>
    {renderOptions(props.options)}
  </>
);



// WEBPACK FOOTER //
// ./src/common/components/select-options/select-options.tsx